export default () => {
  // Toggle nav
  window.addEventListener("DOMContentLoaded", () => {
    const toggleBtn = document.querySelector('#jsMobileNavToggle');
    toggleBtn.addEventListener("click", (e) => { 
      if(document.querySelector('.mainNavMobile').style.display === 'block') {
        document.querySelector('.mainNavMobile').style.display = 'none';
      } else {
        document.querySelector('.mainNavMobile').style.display = 'block';
      }
      
    });
  });
  // Hide mobile nav if window is resized under 1024px

  window.addEventListener('resize', () => {
    if(window.innerWidth > 1024) {
      document.querySelector('.mainNavMobile').style.display = 'none';
    }
  });

}